import styled from "styled-components";

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export default FlexRow;



// WEBPACK FOOTER //
// ./src/components/FlexRow.js